/**
 * Public Route - Guards routes that should only be accessible to signed-out admins
 */

import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { AuthLoader } from './AuthLoader';

export function PublicRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const isAuthTransitionRoute =
    location.pathname === '/auth/verify' || location.pathname === '/auth/callback';

  if (isLoading && !isAuthTransitionRoute) {
    return <AuthLoader />;
  }

  if (isAuthenticated) {
    const from = (location.state as { from?: Location })?.from?.pathname || '/tenants';
    return <Navigate to={from} replace />;
  }

  return <Outlet />;
}
